<template>
  <div name="cases">
    <div class="container">
      <div class="container__left">
        <patient-info class="container__left-profile" />
        <case-search class="container__left-search" />
      </div>
      <query-result class="details" />
    </div>
  </div>
</template>

<script>
import PatientInfo from './components/PatientInfo'
import CaseSearch from './components/CaseSearch'
import QueryResult from './components/QueryResult'
import { mapGetters } from 'vuex'
// import { encounter as encounterRes } from 'resources'

export default {
  components: {
    PatientInfo,
    CaseSearch,
    QueryResult
  },
  computed: {
    ...mapGetters({
      caseId: 'getCaseId',
      encounterId: 'getEncounterId'
    })
    // caseId: this.$router.params.caseId
  },
  watch: {
    caseId: {
      handler: function (cid) {
        // console.log(`Case id updated to ${cid}.`)
        // console.log(this.$store)
        this.$store.dispatch('setCaseId', cid)
        this.$store.dispatch('setEncounterId', 'Initial')
        this.$store.dispatch('unselectQuery')
        this.$store.dispatch('fetchQueries', { caseId: this.caseId, encounterId: this.encounterId })
      }
    },
    encounterId: {
      handler: function (eid) {
        // console.log(`Encounter id updated to ${eid}.`)
        this.$store.dispatch('setEncounterId', eid)
        this.$store.dispatch('unselectQuery')
        this.$store.dispatch('fetchQueries', { caseId: this.caseId, encounterId: this.encounterId })
      }
    }
  },
  mounted () {
    const theCase = this.$route.params.caseId
    this.$store.dispatch('setCaseId', theCase)
    this.$store.dispatch('setEncounterId', 'Initial')
    this.$store.dispatch('fetchQueries', { caseId: theCase, encounterId: 'Initial' })
  }
}
</script>

<style lang="css">
@media (min-width: 1200px) {
  .container {
    /* width: 100%; */
    max-width: 100%;
    float: left;
    height: 90vh;
    display: grid;
    grid-gap: 5px;
    grid-template-columns: 30% 70%;
    /* grid-template-rows: 1fr auto; */
    background-color: #fff;
    color: #444;
  }
  .container__left {
    grid-column: 1/1;
    /* position: relative; */
    display: grid;
    grid-gap: 5px;
    grid-template-rows: 1fr 3fr;
  }
  .container__left-profile {
    grid-row: 1/1;
  }
  .container__left-search {
    grid-row: 2/2;
  }
  .details {
    grid-column: 2/2;
    grid-gap: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Case/CaseViewer.vue